import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import Logo from "@/components/Logo";
import { LockKey, SignIn } from "@phosphor-icons/react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@moonglowscreens.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      localStorage.setItem("mg_admin_token", r.data.token);
      localStorage.setItem("mg_admin_email", r.data.email);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-mg text-white grain relative flex items-center justify-center px-6">
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        {Array.from({ length: 60 }).map((_, i) => (
          <div
            key={i}
            className="twinkle absolute bg-white rounded-full"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              width: `${Math.random() * 2 + 1}px`,
              height: `${Math.random() * 2 + 1}px`,
              animationDelay: `${Math.random() * 4}s`,
            }}
          />
        ))}
      </div>

      <form onSubmit={submit} data-testid="admin-login-form" className="card-lux rounded-lg p-10 w-full max-w-md relative">
        <div className="flex items-center gap-3">
          <Logo size={48} />
          <div>
            <div className="font-display text-lg">
              <span className="gold-gradient-text">Moon</span>
              <span className="silver-gradient-text">Glow</span> Admin
            </div>
            <div className="label-tiny text-[10px] mt-1">Restricted Area</div>
          </div>
        </div>

        <div className="mt-10 divider-lux" />

        <div className="mt-8">
          <label className="label-tiny">Email</label>
          <input
            data-testid="admin-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="field mt-2 rounded-md px-4 py-3 w-full"
            required
          />
        </div>
        <div className="mt-5">
          <label className="label-tiny">Password</label>
          <input
            data-testid="admin-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            className="field mt-2 rounded-md px-4 py-3 w-full"
            required
          />
        </div>

        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="btn-gold rounded-md px-6 py-3 mt-8 w-full text-sm inline-flex items-center justify-center gap-2"
        >
          <LockKey size={16} weight="duotone" /> {loading ? "Signing in…" : "Sign In"}
          <SignIn size={16} weight="bold" />
        </button>

        <div className="mt-6 text-xs text-white/40 text-center">
          Default demo: admin@moonglowscreens.com / Admin@123
        </div>
      </form>
    </div>
  );
}
